import { Component } from "@angular/core";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-toast",
  standalone: true,
  imports: [ToastModule],
  template: `
    <p-toast 
      [showTransitionOptions]="'300ms ease-out'" 
      [hideTransitionOptions]="'300ms ease-in'"
      [baseZIndex]="10000"
      [life]="1000"
      position="top-right">
    </p-toast>
  `,
  styleUrl: "./toast.component.scss"
})
export class ToastComponent {
  constructor() { }
} 